var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRefreshArrow = function SvgRefreshArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 25.1"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 25.1a11 11 0 0 1-11-11 1 1 0 0 1 2 0 9 9 0 1 0 9-9 1 1 0 0 1 0-2 11 11 0 0 1 0 22Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.92 8.2a1 1 0 0 1-.71-.29l-3-3a1 1 0 0 1 0-1.41L11.32.29a1 1 0 0 1 1.41 1.41l-2.44 2.46 2.34 2.34a1 1 0 0 1-.71 1.71Z"
  })));
};
export default SvgRefreshArrow;